module.exports = __webpack_public_path__ + "static/media/dashboard-logo-text.f4ab98a2.svg";